export {PointsEarnedFloater} from "./PointsEarnedFloater";
export type {PointsEarnedFloaterProps} from "./PointsEarnedFloater";
